module.exports = __webpack_public_path__ + "e13312afeae30a99b7d1b1de7ba95e1d.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/minimal/purple@2x.png
// module id = 314
// module chunks = 0